import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Badge } from "react-bootstrap";
import configImage from "../../assets/img/config.jpg";

function CardTorneo({
  torneo,
  handleSeleccionarTorneo,
  handleEliminarTorneo,
  setShowImageModal,
  setTorneoImagen,
}) {
  const [img, setImagen] = useState(torneo.imagen_url);

  const clickTorneo = () => {
    handleSeleccionarTorneo(torneo.id);
  };

  const eliminarTorneo = () => {
    handleEliminarTorneo(torneo.id);
  };

  const nuevaFoto = () => {
    setTorneoImagen(torneo.id);
    setShowImageModal(true);
  };

  useEffect(() => {
    // const randomNumber = Math.floor(Math.random() * 1000) + 1;
    // setImagen(`https://picsum.photos/300/200?random=${randomNumber}`);
    setImagen(configImage);
  }, []);

  return (
    <div
      className="card"
      style={{ width: "18rem", cursor: "pointer", margin: "10px" }}
      onClick={clickTorneo}
    >
      <div style={{ position: "relative" }}>
        <img
          src={img}
          className="card-img-top"
          alt="Imagen desde base de datos"
        />
      </div>
      <div className="card-body">
        <div className="section-typography" style={{ padding: "10px" }}>
          <h6 className="m-0">
            Torneo <span>{torneo?.nombre}</span>
          </h6>
        </div>
        {/* División */}
        <hr style={{ margin: "10px 0" }} />
        {/* Botón Eliminar Torneo */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            eliminarTorneo();
          }}
          className="btn btn-outline-secondary" // Agregar clase de Bootstrap para borde claro
          style={{
            width: "100%", // Ajustar ancho al 100% del contenedor
            borderRadius: "5px", // Bordes redondeados
            cursor: "pointer", // Cambio de cursor al pasar
            transition: "background-color 0.3s", // Transición suave
          }}
        >
          Eliminar torneo
        </button>
      </div>
    </div>
  );
}

export default CardTorneo;
